import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { API } from '@/App';
import { Button } from '@/components/ui/button';
import { CheckCircle, XCircle } from 'lucide-react';

const VerifyEmail = () => {
  const { t } = useTranslation();
  const { token } = useParams();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');
  const verificationAttempted = React.useRef(false);

  useEffect(() => {
    // Prevent double API calls in React Strict Mode
    if (!verificationAttempted.current) {
      verificationAttempted.current = true;
      verifyEmail();
    }
  }, []);

  const verifyEmail = async () => {
    try {
      const response = await axios.get(`${API}/auth/verify/${token}`);
      setStatus('success');
      setMessage(response.data.message);
    } catch (error) {
      setStatus('error');
      setMessage(error.response?.data?.detail || t('verifyEmail.errorGeneric'));
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center py-12 px-4" data-testid="verify-email-page">
      <div className="max-w-md w-full">
        <div className="card text-center animate-fadeIn">
          {status === 'verifying' && (
            <div>
              <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-green-600 mx-auto mb-4" />
              <p className="text-lg text-slate-600">{t('verifyEmail.verifying')}</p>
            </div>
          )}

          {status === 'success' && (
            <div>
              <CheckCircle className="w-16 h-16 text-green-600 mx-auto mb-4" />
              <h2 className="text-2xl font-bold text-slate-900 mb-2">{t('verifyEmail.successTitle')}</h2>
              <p className="text-slate-600 mb-6">{message}</p>
              <Link to="/bess/login">
                <Button className="bg-gradient-to-r from-green-500 to-blue-600 hover:from-green-600 hover:to-blue-700 text-white">
                  {t('verifyEmail.toLogin')}
                </Button>
              </Link>
            </div>
          )}

          {status === 'error' && (
            <div>
              <XCircle className="w-16 h-16 text-red-600 mx-auto mb-4" />
              <h2 className="text-2xl font-bold text-slate-900 mb-2">{t('verifyEmail.errorTitle')}</h2>
              <p className="text-slate-600 mb-6">{message}</p>
              <Link to="/bess/register">
                <Button variant="outline">
                  {t('verifyEmail.backToRegister')}
                </Button>
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
